import { useEffect } from "react";

import PropTypes from "prop-types";
import { Controller, useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Stack,
} from "@mui/material";
import { object, string } from "yup";

import { BankSelect } from "@/features/banks";
import { CustomDialogTitle, CustomInputField } from "@/features/ui";

const DEFAULT_VALUES = {};

const VALIDATION_SCHEMA = object().shape({
  bank: object().required("Harus diisi"),
  accountHolder: string().required("Harus diisi"),
  accountNumber: string()
    .required("Harus diisi")
    .matches(/^\d+$/, "Hanya boleh angka"),
});

export const SellerBankAccountFormDialog = ({
  defaultValues,
  onSubmit,
  onClose,
}) => {
  const {
    control,
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: DEFAULT_VALUES,
    resolver: yupResolver(VALIDATION_SCHEMA),
  });

  useEffect(() => {
    if (defaultValues) reset({ ...DEFAULT_VALUES, ...defaultValues });
  }, [defaultValues, reset]);

  const handleClose = () => {
    reset();
    onClose();
  };

  const onFormSubmit = (data) => {
    onSubmit(data);
    onClose();
  };

  return (
    <Dialog
      open
      fullWidth
      maxWidth="xs"
      component="form"
      onClose={handleClose}
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
        handleSubmit(onFormSubmit)(e);
      }}
    >
      <CustomDialogTitle
        variant="h5"
        title="Rekening Bank"
        onClose={handleClose}
      />
      <DialogContent>
        <Stack spacing={2}>
          <Controller
            control={control}
            name="bank"
            render={({ field, fieldState }) => (
              <BankSelect
                value={field.value}
                onChange={field.onChange}
                TextFieldProps={{
                  required: true,
                  label: "Bank",
                  error: fieldState.invalid,
                  helperText: fieldState.error?.message,
                  InputProps: {
                    placeholder: "Pilih",
                  },
                }}
              />
            )}
          />
          <CustomInputField
            required
            control={control}
            name="accountNumber"
            label="No. Rek."
            register={register}
            helperText={errors.accountNumber?.message}
            error={Boolean(errors.accountNumber)}
          />
          <CustomInputField
            required
            control={control}
            name="accountHolder"
            label="Atas Nama"
            register={register}
            helperText={errors.accountHolder?.message}
            error={Boolean(errors.accountHolder)}
            InputProps={{
              placeholder: "Cth: John Doe",
            }}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" type="submit">
          Simpan
        </Button>
      </DialogActions>
    </Dialog>
  );
};

SellerBankAccountFormDialog.propTypes = {
  defaultValues: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
